import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import ConstructorCallout from '#client/components/ConstructorCallout';

function FilingGuaranteeCallout() {
  return (
    <ConstructorCallout
      description={
        <FormattedMessage id="shopping.page.checkout.callout.filingGuarantee.description" />
      }
      title={<FormattedMessage id="shopping.page.checkout.callout.filingGuarantee" />}
    />
  );
}

export default FilingGuaranteeCallout;
